import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { useNavigate } from "react-router-dom";

import { Project } from "interfaces";
import { FooterCardProject, HeaderCardProject } from "./components";
import { useAppDispatch } from "store/store";
import { resetInitialStateDetailProject } from "store/slicer/GestioneDetailProjectSlice";
import { resetInitialStateSaveAnswer } from "store/slicer/GestioneSaveAnswerSlice";
import { resetStateChat } from "store/slicer/GestioneChatSlice";
import { setCurrentProject } from "store/slicer/GestioneProjectsSlice";

export const CardProject = ({ project }: { project: Project }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const goToProjectDashboard = () => {
    dispatch(resetInitialStateDetailProject());
    dispatch(resetInitialStateSaveAnswer());
    dispatch(resetStateChat());
    dispatch(setCurrentProject(project as any));
    navigate(`/bo/project?id=${project.id}`);
  };

  return (
    <Card
      className="card-project cta"
      onClick={goToProjectDashboard}
      header={<HeaderCardProject project={project} />}
      footer={<FooterCardProject project={project} />}
    >
      <Divider />
    </Card>
  );
};
